import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import skillsuprise from "../assets/skillsuprise.png";

const Footer = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const session = localStorage.getItem("session_id");
    setIsLoggedIn(!!session);
  }, []);

  return (
    <footer className="footer-section">

      <Container className="py-5">

        <Row className="gy-4">

          {/* 🔥 LOGO + DESC */}
          <Col md={4}>
            <img
              src={skillsuprise}
              alt="logo"
              height="40"
              className="mb-3"
            />

            <p className="text-muted small">
              Skills Uprise is a modern assessment platform designed to help
              students evaluate their knowledge with real-time tracking,
              performance analytics, and secure online exams.
            </p>
          </Col>

          {/* 🔥 NAV LINKS */}
          <Col md={4}>
            <h6 className="fw-bold mb-3">Quick Links</h6>

            <div className="d-flex flex-column gap-2">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/courses" className="footer-link">Courses</Link>

              {isLoggedIn && (
                <Link to="/dashboard" className="footer-link">
                  Dashboard
                </Link>
              )}

              <Link to="/internships" className="footer-link">Internships</Link>
              <Link to="/instructions" className="footer-link">Instructions</Link>
              <Link to="/gallery" className="footer-link">Gallery</Link>
              <Link to="/faq" className="footer-link">FAQ</Link>
            </div>
          </Col>

          {/* 🔥 CONTACT / INFO */}
          <Col md={4}>
            <h6 className="fw-bold mb-3">Contact</h6>

            <p className="small text-muted mb-1">📧 support@skillsuprise.com</p>
            {/* <p className="small text-muted mb-1">📞 +91 9876543210</p> */}
            <p className="small text-muted">
              📍 India - Online Learning Platform
            </p>
          </Col>

        </Row>

        {/* 🔥 BOTTOM BAR */}
        <div className="text-center mt-4 pt-3 border-top small text-muted">
          © {new Date().getFullYear()} Skills Uprise. All rights reserved.
        </div>

      </Container>

      {/* 🔥 STYLES */}
      <style>{`
        .footer-section {
          background: #ffffff;
          border-top: 1px solid #eaeaea;
        }

        .footer-link {
          text-decoration: none;
          color: #555;
          font-size: 14px;
          transition: 0.2s;
        }

        .footer-link:hover {
          color: #0d6efd;
          padding-left: 5px;
        }
      `}</style>

    </footer>
  );
};

export default Footer;